module.exports = __webpack_public_path__ + "img/anatomy-for-sculptors-form-of-the-hex-and-neck-mouth-area-anatomy-for-sculptors-h1000-optimized.d41505af.jpg";